module.exports = "/_next/static/images/T2_hires-fa069d3bfe1ca7316a95e59fe5cd1a62.png";